var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"bg"}),_c('Logo'),_c('Navbar'),_c('div',{attrs:{"id":"wrapper"}},[(this.$store.getters.showLoader)?_c('Loader'):_vm._e(),_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }